import { CzMaxPrice } from './CzMaxPrice';
import { mapFinalCalculation, RawFinalCalculation } from './mapFinalCalculation';
import { mapProduct, RawProduct } from './mapProduct';
import { Reference } from './Reference';

export interface RawCzMaxPrice {
	reference: {
		packageSize: number | null;
		referenceBasketVersion: string;
	};
	products: RawProduct[];
	finalCalculation: RawFinalCalculation;
	_links: { [key: string]: string };
}

export function mapCzMaxPrice(czMaxPrice: RawCzMaxPrice): CzMaxPrice {
	return new CzMaxPrice(
		new Reference(czMaxPrice.reference.packageSize, czMaxPrice.reference.referenceBasketVersion),
		czMaxPrice.products.map(mapProduct),
		mapFinalCalculation(czMaxPrice.finalCalculation),
		czMaxPrice._links
	);
}
